export enum CardVariant {
  FRONT = 'front',
  THUMBNAIL = 'thumbnail',
  BACK = 'back',
}
